import * as React from "react";
import { SVGProps, memo } from "react";

const SvgDispensing = (props: SVGProps<SVGSVGElement>) => (
  <svg width={27} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.467 26.238c.69 0 1.25-.56 1.25-1.25V1.875c0-.69-.56-1.25-1.25-1.25H2.469c-.69 0-1.25.56-1.25 1.25v23.113c0 .69.56 1.25 1.25 1.25h15.998Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.75 1.875c0-.95.77-1.719 1.719-1.719h15.998c.95 0 1.719.77 1.719 1.719v23.113c0 .95-.77 1.719-1.719 1.719H2.469c-.95 0-1.719-.77-1.719-1.72V1.876Zm1.719-.781a.781.781 0 0 0-.781.781v23.113c0 .431.35.781.78.781h15.999c.431 0 .781-.35.781-.781V1.875a.781.781 0 0 0-.781-.781H2.469Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.06 16.004c0-.259.21-.469.47-.469h9.947a.469.469 0 1 1 0 .938H5.529a.469.469 0 0 1-.469-.47ZM5.06 18.886c0-.26.21-.469.47-.469h9.947a.469.469 0 1 1 0 .938H5.529a.469.469 0 0 1-.469-.47ZM5.06 21.767c0-.259.21-.469.47-.469h9.947a.469.469 0 0 1 0 .938H5.529a.469.469 0 0 1-.469-.469Z"
      fill="#194D33"
    />

    <path
      d="M10.923 5.589 7.491 9.021a1.85 1.85 0 1 0 2.617 2.617l3.432-3.432a1.85 1.85 0 1 0-2.617-2.617Z"
      fill="#8CD9B2"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.828 8.358 3.433-3.432a2.788 2.788 0 1 1 3.942 3.943l-3.432 3.432a2.788 2.788 0 1 1-3.943-3.943Zm.663.663 3.432-3.432a1.85 1.85 0 1 1 2.617 2.617l-3.432 3.432a1.85 1.85 0 1 1-2.617-2.617Z"
      fill="#194D33"
    />

    <path
      d="m13.541 8.205-1.746 1.748L9.178 7.34l1.746-1.748a1.856 1.856 0 0 1 2.617 0 1.857 1.857 0 0 1 0 2.612Z"
      fill="#4DB27F"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.603 10.401 8.72 7.52l.663-.663 2.882 2.881-.663.663Z"
      fill="#194D33"
    />

    <circle cx={18.094} cy={22.5} r={8.281} fill="#fff" stroke="#194D33" strokeWidth={0.938} />

    <mask
      id="Dispensing_svg__a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={11}
      y={14}
      width={15}
      height={16}
    >
      <path
        transform="rotate(-90 11.219 29.07)"
        fill="#D9D9D9"
        d="M11.219 29.07h14.695v14.695H11.219z"
      />
    </mask>

    <g mask="url(#Dispensing_svg__a)">
      <path
        d="m22.527 18.429-4.091 10.023a.458.458 0 0 1-.336.281.417.417 0 0 1-.41-.119l-5.954-5.953a.418.418 0 0 1-.12-.411.457.457 0 0 1 .282-.336l10.023-4.091a.433.433 0 0 1 .498.108c.145.144.18.31.108.498Zm-4.708 9.016L21.25 19.1l-8.378 3.399 1.819 1.818 3.29-1.948-1.97 3.269 1.808 1.807Z"
        fill="#194D33"
      />
    </g>
  </svg>
);

const Memo = memo(SvgDispensing);

export default Memo;
